export const windowReady = typeof window !== 'undefined'
export const navigatorReady = typeof navigator !== 'undefined'
